import { TCRColumnLayout } from "./TCRColumnLayout";
import { ThemeContext } from "./ThemeContext";

export const PaydayLoansCompany = (props) => (
	<ThemeContext.Provider value={{ hasTrustPilotWidget: false }}>
		<TCRColumnLayout {...props} />
	</ThemeContext.Provider>
);
